import { TradingRepo as tradingRepo } from '../trading/trading.repo';



class TradingAdminController implements angular.IOnInit {

  public pendingTradeSets: Array<any>;
  public finalisedTradeSets: Array<any>;
  public completedTradeSets: Array<any>;
  public isLoading = false;

  /** @ngInject */
  constructor(private tradingRepo: tradingRepo, private $window: angular.IWindowService) {


  }

  $onInit() {
    
  }

  
  
}



export const tradingAdmin: angular.IComponentOptions = {
  template: require('./tradingadmin.html'),
  controller: TradingAdminController
};




// WEBPACK FOOTER //
// ./src/app/tradingadmin/tradingadmin.ts